
import axios from 'axios';
import { BASE_API } from 'config/consts';
import {
  FETCH_GROUPING_USER_REQUEST,
  FETCH_GROUPING_USER_SUCCESS,
} from './types';

const URL_GROUPING_USER = `${BASE_API}/grouping-user`;

// Actions
export const fetchGroupingUserRequest = () => ({ type: FETCH_GROUPING_USER_REQUEST });
export const fetchGroupingUserSuccess = (data) => ({ type: FETCH_GROUPING_USER_SUCCESS, payload: data });

export const fetchGroupingUser = (userId) => {
  return (dispatch) => {
    dispatch(fetchGroupingUserRequest());
    axios
      .get(`${URL_GROUPING_USER}/${userId}`)
      .then((response) => {
        dispatch(fetchGroupingUserSuccess(response.data));
      });
  };
};
